module.exports = __webpack_public_path__ + "static/wiki-a116d1862b119b5ecc255b7b84ec62b5.png";